/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard, GuestGuard } from "@app/@core/guards";
import { UserResolverService } from "@app/@core/resolvers";

import { Google2FAComponent, SetupGoogle2FAComponent, TvSalesProductionComponent } from "@auth/components";

const routes: Routes = [
  {
    path: "",
    redirectTo: "authenticated",
    pathMatch: "full",
  },

  // User authenticated
  {
    path: "authenticated",
    loadChildren: () => import("@auth/authenticated.module").then((m) => m.AuthenticatedModule),
    canActivate: [AuthGuard],
    resolve: {
      response: UserResolverService,
    },
  },

  // TV Screens (Production)
  {
    path: "production",
    // canActivate: [AuthGuard],
    component: TvSalesProductionComponent,
    data: { title: "Production Summary" },
  },

  // User authenticated (2fa Setup)
  {
    path: "otp-setup",
    canActivate: [AuthGuard],
    component: SetupGoogle2FAComponent,
    data: { title: "Setup Google 2FA" },
  },

  // User authenticated (2fa Verification)
  {
    path: "otp-verification",
    canActivate: [AuthGuard],
    component: Google2FAComponent,
    data: { title: "OTP Verification" },
  },

  // User not authenticated, proceed with authentication
  {
    path: "auth",
    loadChildren: () => import("@guest/modules/auth/auth.module").then((m) => m.AuthModule),
    canActivate: [GuestGuard],
  },

  // Customer
  {
    path: "public",
    loadChildren: () => import("@guest/modules/public/public.module").then((m) => m.PublicModule),
  },

  // Customer
  {
    path: "disc",
    redirectTo: "/public/disc",
    pathMatch: "full",
  },

  // Fallback when no prior routes is matched
  { path: "**", redirectTo: "authenticated", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
